// extracted by mini-css-extract-plugin
export default {"button":"Button_button__MD1VM","load":"Button_load__8zUOD","animate":"Button_animate__BefD1"};